import type { _Dict } from "./dict";

export function tryrequire(modpath: string) {
  try {
    return require(modpath);
  } catch (any) {
    // console.error('未找到或解析错误，跳过加载：' + modpath)
    return {};
  }
}

export function clearSpace(str: string): string {
  // 业务恻可能存在传递非字符进行翻译的异常代码
  try {
    const replaced = str.replace(/\s+/g, "");
    // @caveats: i18next 会根据 if(key) 设定翻译路径，
    // 若替换后为 falsy 值会导致路径错误，统一返回 " "
    // see -> https://github.com/i18next/i18next/blob/f6aea8d40039e4593dfcb0dabb54ad6d1ba14f85/src/ResourceStore.js#L60
    if (!replaced) {
      return " ";
    }
    return replaced;
  } catch {
    return str;
  }
}

/**
 * tea scan出来的词条hash key过滤掉了空格 https://git.woa.com/tea-design/tea2/blob/master/tea-app/src/core/i18n.tsx#L22
 * 导致有些词条过滤空格之后计算的hash key是一样的，而计费的词典用中文做key，是区分空格的，计费的词典依据tea扫描产物生成，会缺失部分中文词条
 * 避免i18n版本差异，不影响createDictJson生成的词典，运行时对添加的词典运行时过滤空格, 同时在翻译时对待翻译词条过滤空格
 */
export function clearTranslationSpace(obj: _Dict): _Dict {
  const ans = {};
  Object.entries(obj).forEach(([key, val]) => {
    ans[clearSpace(key)] = val;
  });
  return ans;
}
